import {Flexbox} from "../Flexbox";
import {SelectableColourSwatch} from "../ColourSwatch/SelectableColourSwatch";

export const ColourPaletteSelection = ({colours, setColours, selectedColours, setSelectedColours}) => {
    return (
        <Flexbox
            gap={16}
            padding={16}
            // @ts-ignore
            borderRadius={[12, 0, 0, 12]}
            height="65vh"
            overflowY="scroll"
            backgroundColour="#f9f9fb"
        >
            {colours.map((colour) => {
                return (
                    <SelectableColourSwatch
                        key={colour.id}
                        id={colour.id}
                        currentColour={colour}
                        colours={colours}
                        setColours={setColours}
                        selectedColours={selectedColours}
                        setSelectedColours={setSelectedColours}
                    />
                );
            })}
        </Flexbox>
    );
}